import { SECTION_NAMES } from '@bridebook/web/lib/wedding-website/constants';
import { ReactNode } from 'react';
import { MotifFaq } from './motif-faq';
import { MotifGiftList } from './motif-gift-list';
import { MotifHotels } from './motif-hotels';
import { MotifSchedule } from './motif-schedule';
import { MotifStory } from './motif-story';
import { MotifVenue } from './motif-venue';

/**
 * Maps section names to their Motif (BEM) render components.
 * Consumed by buildContentSections to render reorderable sections in website.sections order.
 */
export const MOTIF_SECTION_COMPONENTS: Record<string, ReactNode> = {
  [SECTION_NAMES.OUR_STORY]: <MotifStory />,
  [SECTION_NAMES.SCHEDULE]: <MotifSchedule />,
  [SECTION_NAMES.PRIMARY_VENUE]: <MotifVenue />,
  [SECTION_NAMES.GIFT_LIST]: <MotifGiftList />,
  [SECTION_NAMES.HOTELS]: <MotifHotels />,
  [SECTION_NAMES.FAQ]: <MotifFaq />,
};
